module.exports = __webpack_public_path__ + "img/sup_deposit_crypto8.73426e5e.jpg";